"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
var List_1 = __importDefault(require("@material-ui/core/List"));
var SortableItem_1 = __importDefault(require("./SortableItem"));
var SortableList = (0, react_sortable_hoc_1.SortableContainer)(function (_a) {
    var items = _a.items, onChangeColumn = _a.onChangeColumn;
    return (react_1.default.createElement(List_1.default, null,
        items.map(function (item, index) {
            var id = item.id, visible = item.visible, _a = item.noFilter, noFilter = _a === void 0 ? false : _a, _b = item.isStatic, isStatic = _b === void 0 ? false : _b, label = item.label;
            return !noFilter ? (react_1.default.createElement(SortableItem_1.default, { index: index, checked: visible, id: id, isStatic: isStatic, onChangeColumn: onChangeColumn, label: label, disabled: isStatic })) : null;
        }),
        ";"));
});
exports.default = SortableList;
